/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { OnInit, OnDestroy, Directive } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UntypedFormGroup } from '@angular/forms';

import { AccountCreationStore } from '../auth/services/account-creation-store.service';
import { LoadingBlockerState } from '../utility-components/loading-blocker';
import { Router } from '@angular/router';
import { RallyPointService } from 'src/app/services/rally-point.service';

@Directive()
export abstract class RallyBaseComponent implements OnInit, OnDestroy {
	protected shutdownSubject = new Subject<void>();
	public loadingChanged = new Subject<any>();
	public loadingSet = new Subject<any>();

	public rallyForm: UntypedFormGroup;

	constructor(
		protected router: Router,
		protected rallyPointService: RallyPointService,
		protected accountCreationStore: AccountCreationStore
	) {}

	public abstract next();

	public redirect(testResult) {
		if (testResult.route) {
			this.accountCreationStore.setLoadingState(LoadingBlockerState.complete);
		} else {
			this.accountCreationStore.setLoadingState(LoadingBlockerState.failure);
		}
		if (testResult.message) {
			Logging.warning(testResult.message);
		}

		this.router.navigate(testResult.route);
	}

	public ngOnInit() {
		this.accountCreationStore.accessCode$
			.pipe(
				takeUntil(this.shutdownSubject),
				//to avoid making the input(s?) invalid when leaving the route
				//could probably alternatively remove this listener entirely or take(1)
				takeUntil(this.accountCreationStore.nukeObs$)
			)
			.subscribe((accessCode) => {
				this.rallyForm.patchValue({ accessCode });
			});
	}

	public ngOnDestroy() {
		this.shutdownSubject.next();
	}
}
